import { context } from '@wikia/ad-engine';

export function getSeedtagContext(): object {
	const midBoxAdConfigs = context.get('options.replaceOpenWebWithMidBoxAd')
		? {
				mid_boxad: {
					sizes: [[300, 250]],
					publisherId: '4677-9425-01',
					adUnitId: '34398375',
					placement: 'inArticle',
				},
			}
		: {};

	return {
		enabled: false,
		slots: {
			top_leaderboard: {
				sizes: [
					[728, 90],
					[970, 250],
				],
				publisherId: '4677-9425-01',
				adUnitId: '33908056',
				placement: 'inBanner',
			},
			top_boxad: {
				sizes: [
					[300, 250],
					[300, 600],
				],
				publisherId: '4677-9425-01',
				adUnitId: '33908055',
				placement: 'inArticle',
			},
			...midBoxAdConfigs,
			incontent_leaderboard: {
				sizes: [[728, 90]],
				publisherId: '4677-9425-01',
				adUnitId: '33908061',
				placement: 'inBanner',
			},
			incontent_boxad: {
				sizes: [
					[300, 250],
					[300, 1050],
				],
				publisherId: '4677-9425-01',
				adUnitId: '33908059',
				placement: 'inArticle',
			},
			bottom_leaderboard: {
				sizes: [
					[728, 90],
					[970, 250],
				],
				publisherId: '4677-9425-01',
				adUnitId: '33974336',
				placement: 'inBanner',
			},
			featured: {
				sizes: [[0, 0]],
				publisherId: '4677-9425-01',
				adUnitId: '33908063',
				placement: 'inStream',
			},
		},
	};
}
